import { FormValues } from 'donate/types'
import { connect } from 'formik'
import { useEffect } from 'react'

export const CodonationWatcher = connect<{}, FormValues>(
  ({
    formik: {
      values: { amount_cents, ...values },
      ...formik
    },
  }) => {
    useEffect(() => {
      if (formik.touched.codonation_cents) return
      if (values._show_codonation) {
        const codonationCents = values._codonation_calculator.suggest(amount_cents)
        void formik.setFieldValue('codonation_cents', codonationCents)
      }
      // TODO: Check this ish if it really does not need deps
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [amount_cents])

    return null
  }
)
